<template>

    <section v-if="$store.state.isLoggedIn != null && $store.state.isLoggedIn === false" class="teams-portal-login container-fluid w-100 h-100">

        <!-- Login main picture -->
        <div class="col-lg-8 col-md-7 login-main-picture d-none d-md-flex">
            <img src="static/img/login.png" alt="Login img">
        </div>

        <!-- Right Column (Login Form)-->
        <div class="col-lg-4 col-md-5 col-12 right-column h-100 d-flex flex-column justify-content-center align-items-center">

          <div class="company-details">
            <img src="static/img/ConvertLabs.svg" alt="CL">
            <h2 class="mb-0">Service Providers</h2>
          </div>

          <el-form :hide-required-asterisk="true" ref="form" :model="form" class="login-form px-0 px-md-3 w-100">
            <input type="hidden" name="_token" value="" v-model="token">

            <div v-if="!linkSent" v-loading="loading">

              <!-- Team Email Input -->
              <el-form-item prop="email" label="Your Team Email" :rules="[validationRules.required, validationRules.email]" class="team-email">
                <el-input v-model="form.email" name="email" placeholder="john@example.net" />
              </el-form-item>

              <!-- <p class="forgot-pass mb-0">
                  <router-link to="/auth-re-password" class="text-dark font-weight-bold">Forgot password ?</router-link>
              </p> -->

              <!-- Login button -->
              <el-button type="primary" @click.stop.prevent="processLogin()" class="w-100">Login</el-button>

              <div class="link-validation" v-if="$store.state.signinError">
                {{ $store.state.signinError }}
              </div>

            </div>

            <div v-else>
              <p class="login-link text-center">
                We've sent you a login link to {{form.email}}. Only valid for the next 10hrs.
                <br><br>
                Can't find the link? Check your spam folder<br><br>
              </p>

              <div class="d-flex justify-content-around">
                <a target="_blank" class="c-link c-button-unstyled margin_right_250 p-get_started__email_app_link" href="https://mail.google.com/mail/u/0/" rel="noopener noreferrer">
                  <img class="margin_right_50" alt="" srcset="https://a.slack-edge.com/bv1-9/get-started-icon-gmail-b3b3a57.png, https://a.slack-edge.com/bv1-9/get-started-icon-gmail@2x-e80b706.png 2x">
                  Open Gmail
                  <span aria-label="(se abre una pestaña nueva)"></span>
                </a>

                <a target="_blank" class="c-link c-button-unstyled p-get_started__email_app_link" href="https://outlook.live.com/mail/0/inbox" rel="noopener noreferrer">
                  <img class="margin_right_50" alt="" srcset="https://a.slack-edge.com/bv1-9/get-started-icon-outlook-55f9ac5.png, https://a.slack-edge.com/bv1-9/get-started-icon-outlook@2x-4cc97d5.png 2x">
                  Open Outlook
                  <span aria-label="(se abre una pestaña nueva)"></span>
                </a>
              </div>


            </div>

          </el-form>

        </div>

    </section>

</template>


<script>

import {

  HomeIcon,
  UserIcon,
  KeyIcon
} from 'vue-feather-icons'

/**
 * Auth-login component
 */
export default {
  data () {
    return {
      token: '',
      email: '',
      pass: '',
      linkSent: false,
      loading: false,
      form: {
        email: ''
      },
      validationRules: {
        required: { required: true, trigger: ['change', 'blur'], message: 'Required Field' },
        phone: { pattern: /^\+[0-9]+$/, message: 'Phone format +12345679', trigger: ['change', 'blur']},
        email: {type: 'email', trigger: ['change', 'blur'], message: 'Email is not valid'},
        url: {type: 'url', trigger: ['change', 'blur'], message: 'URL is not valid, it should include the protocol http(s)'},
        domainName: {pattern: /^(?!:\/\/)([a-zA-Z0-9]+\.)?[a-zA-Z0-9][a-zA-Z0-9-]+\.[a-zA-Z]{2,6}?$/i, message: 'Domain Name is not valid, it should not include protocol http(s)', trigger: ['change', 'blur']}
      }
    }
  },

  mounted () {
  },

  components: {

    HomeIcon,
    UserIcon,
    KeyIcon
  },

  methods: {



    processLogin () {

      this.$refs['form'].validate((valid, obj) => {
        if (valid) {
          this.loading = true
          this.$post('api/teams/login/link', {email: this.form.email}).then((response) => {
            if (response.ok) {
              response.json().then((result) => {
                this.linkSent = result.success
              })
            }
          }).finally(() => {
            this.loading = false
          })
        }
      })
    }
  }
}
</script>

<style scoped>

.teams-portal-login {
    display: flex;
}
.login-main-picture {
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
}
.login-main-picture img {
    max-width: 550px;
}
.company-details {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 48px;
}
.company-details img {
    max-width: 250px;
    width: 100%;
    margin-bottom: 16px;
}
.company-details h2 {
    font-size: 18px;
    font-weight: 500;
}
.right-column {
    background-color: white;
}

</style>



// WEBPACK FOOTER //
// src/views/auth/login.vue